import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hz_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const money = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n || 0);

export const priceLabel = (amount, pending) => {
  if (pending) return "Por definir";
  if (!amount || amount === 0) return "Sin costo";
  return money(amount);
};

export const fileUrl = (path) =>
  path && path.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : path;

export function apiError(err, fallback = "Ocurrió un error. Intenta de nuevo.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
